import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const container = document.getElementById('root'); // El ID de tu contenedor de la app
const root = createRoot(container); // Crea una raíz con 'createRoot'

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);